import { render, staticRenderFns } from "./filedownload.vue?vue&type=template&id=53230084&"
import script from "./filedownload.vue?vue&type=script&lang=js&"
export * from "./filedownload.vue?vue&type=script&lang=js&"
import style0 from "./filedownload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports